"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledConfirmationDescription = exports.StyledPrintButtonContainer = exports.StyledConfirmationAction = exports.StyledConfirmationBody = exports.StyledConfirmationTitle = exports.StyledConfirmationContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.StyledConfirmationContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ isAboveMd }) => isAboveMd ? (0, ui_theme_1.fromTheme)('spacing_large') : (0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.StyledConfirmationTitle = styled_1.default.div `
  display: flex;
  align-items: center;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  > svg {
    color: ${(0, ui_theme_1.fromTheme)('color_icon_green')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_3')};
  }
`;
exports.StyledConfirmationBody = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_xxlarge')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
`;
exports.StyledConfirmationAction = styled_1.default.div `
  display: flex;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  @media screen and (max-width: ${(0, ui_theme_1.fromTheme)('db_screen_medium')}) {
    position: ${({ aboveMd }) => (!aboveMd ? 'fixed' : 'static')};
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    align-items: center;
    padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} ${(0, ui_theme_1.fromTheme)('spacing_large')};
    background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
    border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
      ${(0, ui_theme_1.fromTheme)('color_border')};
    z-index: 1000;

    div {
      flex: 1;
    }
    button {
      width: 100%;
    }
  }

  @media print {
    display: none;
    @page {
      margin: 0;
    }
  }
`;
exports.StyledPrintButtonContainer = styled_1.default.div `
  display: flex;
`;
exports.StyledConfirmationDescription = styled_1.default.p `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  margin: 0;
`;
//# sourceMappingURL=styles.js.map